<template lang="pug">
Page.post-edit
    .post-edit__top(
        slot="header"
    )
        h1.post-edit__title
            | Редактирование статьи

        SvMenu(
            @copy="copy"
            @remove="remove"
        )

    SvTabs.post-edit__table(
        v-model="currentTab"
        :tabs="['Основное', 'SEO']"
        :current="0"
    )
        .post-edit__actions
            SvButton.post-edit__action(
                view="secondary"
                text="Отмена"
                :prependIcon=`{
                    icon: 'cancel',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="resetForm"
            )

            SvButton.post-edit__action(
                view="secondary"
                text="Применить"
                :prependIcon=`{
                    icon: 'refresh',
                    width: 24,
                    height: 24,
                    hover: '#1993EB',
                    default: '#B7BAC6'
                }`
                @click="save(false)"
            )

            SvButton.post-edit__action(
                view="primary"
                text="Сохранить"
                :prependIcon=`{
                    icon: 'check',
                    width: 24,
                    height: 24,
                    default: '#1993EB',
                    hover: '#1993EB'
                }`
                @click="save(true)"
            )
    keep-alive
        .post-edit__form(
            v-if="currentTab === 0"
        )
            .post-edit__form-item
                span.post-edit__form-title
                    | Активность

                .post-edit__form-elements--small.radio
                    SvRadio.post-edit__form-radio(
                        v-model="is_active"
                        :value="true"
                        label="Да"
                    )

                    SvRadio.post-edit__form-radio(
                        v-model="is_active"
                        :value="false"
                        label="Нет"
                    )

            .post-edit__form-item
                span.post-edit__form-title
                    | Заголовок

                .post-edit__form-elements--small
                    SvInput(
                        v-model="title"
                        color="graylight"
                        placeholder="Например: построен бассейн"
                        :withIcon="false"
                    )

            .post-edit__form-item
                span.post-edit__form-title
                    | Символьный код

                .post-edit__form-elements--small
                    SvInput(
                        v-model="alias"
                        placeholder="Например: Hot_News"
                        color="graylight"
                        :withIcon="false"
                    )


            .post-edit__form-item
                span.post-edit__form-title
                    | Кол-во просмотров

                .post-edit__form-elements--small
                    SvInput(
                    v-model="views_count"
                    mask="numeric"
                    color="graylight"
                    placeholder="Например: 100"
                    :withIcon="false"
                    )

            .post-edit__form-item
                span.post-edit__form-title
                    | Фото

                .post-edit__form-elements--small
                    SvUpload(
                        v-model="original_image"
                    )

            .post-edit__form-item
                span.post-edit__form-title
                    | Анонс

                .edit__form-elements--large
                    ckeditor(
                        v-model="preview_text"
                        :editor="editor"
                        :config="editorConfig"
                    )

            .post-edit__form-item
                span.post-edit__form-title
                    | Полное описание

                .edit__form-elements--large
                    ckeditor(
                        v-model="detail_text"
                        :editor="editor"
                        :config="editorConfig"
                    )
    keep-alive
        FormPostSeo(
            v-if="currentTab === 1"
        )

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvMenu from '@/components/uikit/SvMenu.vue';
import Page from '@/layouts/page.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvButton from '@/components/uikit/SvButton.vue';
import SvTabs from '@/components/uikit/SvTabs.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';
import SvSelectList from '@/components/uikit/SvSelectList.vue';
import { rusToLatin } from '@/helpers/transform';
import '@ckeditor/ckeditor5-build-classic/build/translations/ru';
import MultiLoad from '@/components/forms/subforms/MultiLoad.vue';
import PhotoBlockLight from '@/components/forms/subforms/PhotoBlockLight.vue';
import SvTextarea from '@/components/uikit/SvTextarea.vue';
import FormPostSeo from '@/components/forms/FormPostSeo.vue';

export default {
  name: 'PostEdit',

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        ckfinder: {
          // Upload the images to the server using the CKFinder QuickUpload command.
          // uploadUrl: '/admin/developers/' + this.$route.params.id + '/upload-inline-image',

          // Define the CKFinder configuration (if necessary).
          // options: {
          //   resourceType: 'Images',
          //   pass: 5,
          // },
        },
        toolbar: {
          viewportTopOffset: 0,
        },
        language: 'ru',
      },
      currentTab: 0,
    };
  },

  beforeMount() {
    this.$store.dispatch('post/getById', this.$route.params.id);
  },

  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== 'new') {
      this.$store.dispatch('post/getById', to.params.id);
    }
    next();
  },
  mounted() {
  },

  computed: {
    ...mapGetters({
      current: 'post/getCurrent',
    }),

    is_active: {
      get() {
        // Обертка Boolean, т.к. с севера приходит 1 или 0
        return Boolean(this.current.is_active);
      },
      set(is_active) {
        this.setValue({ is_active });
      },
    },

    views_count: {
      get() {
        return this.current.views_count;
      },
      set(views_count) {
        this.setValue({ views_count });
      },
    },

    title: {
      get() {
        return this.current.title;
      },
      set(title) {
        this.setValue({ title });
        this.setValue({ alias: rusToLatin(this.title) });
      },
    },

    alias: {
      get() {
        return this.current.alias;
      },

      set(alias) {
        this.setValue({ alias });
      },
    },

    original_image: {
      get() {
        return this.current.original_image;
      },

      set(original_image) {
        this.setValue({ original_image });
      },
    },

    preview_text: {
      get() {
        return this.current.preview_text;
      },
      set(preview_text) {
        this.setValue({ preview_text });
      },
    },

    detail_text: {
      get() {
        return this.current.detail_text;
      },
      set(detail_text) {
        this.setValue({ detail_text });
      },
    },

  },

  methods: {
    ...mapMutations({
      setValue: 'post/setValue',
      // addImage: 'post/addImage',
    }),

    resetForm() {
      this.$store.commit('post/clearCurrent');
      this.$router.push({ name: 'posts' });
    },

    copy() {
      this.$store.commit('post/setCurrent', this.$route.params.id);
      this.setValue({ id: null });
      this.$router.push({ name: 'post-edit', params: { id: 'new' } });
    },

    async remove() {
      await this.$store.dispatch('post/remove', this.$route.params.id);
      this.$router.push({ name: 'posts' });
    },

    async save(isRedirect = false) {
      const data = await this.$store.dispatch('post/save');
      let id = typeof data === 'number' ? data : (data.data && data.data.id);
      console.log("save -> data", data)
      console.log("save -> id", id)
      if (!isRedirect) {
        this.$router.push({
          name: 'post-edit',
          params: {
            id,
          },
        }).catch(err => {});
      } else {
        this.resetForm();
      }
    },

    uploaded(files) {
      files.forEach((image) => {
        const gallery = this.current.gallery.slice();
        gallery.push({image});
        this.setValue({gallery})


        // this.addImage({image})
      });
    },

    changePhoto(obj, index){

      const gallery = this.current.gallery.slice();
      gallery.splice(index, 1, obj);
      this.setValue( {gallery} );



    },

    removePhoto(index) {
      const gallery = this.current.gallery.slice();
      gallery.splice(index, 1);
      this.setValue( {gallery} );

    }
  },

  components: {
    Page,
    SvInput,
    SvButton,
    SvTabs,
    SvMenu,
    SvRadio,
    SvUpload,
    SvSelectList,
    MultiLoad,
    PhotoBlockLight,
    SvTextarea,
    FormPostSeo,
  },
};
</script>

<style lang="scss" scoped>
.post-edit__title {
    margin: 10px 0 19px 0;
    font-size: 46px;
    font-weight: 500;
    color: #404450;
}

.post-edit__form-title {
    display: flex;
    justify-content: flex-end;
    margin-right: 49px;
    align-items: center;
}

.post-edit__form-item {
    display: grid;
    grid-template-columns: 291px 1fr;
    margin-top: 26px;
}

.post-edit__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.post-edit__form-elements--small {
    width: 311px;

    &.radio {
        display: flex;
    }
}

.post-edit__form {
    padding: 50px 0;
}

.post-edit__form-radio {
    margin-right: 21px;
}

.post-edit__form-elements--medium {
    width: 495px;
}

.post-edit__actions {
    display: flex;
    align-items: center;
    height: 100%;
}

.post-edit__search {
    width: 47%;
    min-width: 280px;
}
.gallery__photoes {
  display: flex;
  flex-wrap: wrap;
  margin: 10px -10px;
}
.photo-item-wrapper {
  padding: 10px;
}
.post-edit__form-elements--large {
  max-width: 710px;
  margin-right: 20px;
}
</style>
